












require('axios')
import { Component, Prop, Vue } from 'vue-property-decorator';
import NewApi, { BasePath, ImagePath, ImageThumbPath, ImageCoverPath } from '../ts/api';
import { DefaultApi, Image, Credentials } from '../api';

import CoolLightBox from "vue-cool-lightbox";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";


let api: DefaultApi;

@Component(
  {
    components:{
CoolLightBox,
    }
  }
)
export default class Newest extends Vue {
  imgs = [] as Image[];
  lbData = [] as any
  index = -1
  
  mounted(){
    api = NewApi()
    this.getNewest()
  }

  getNewest(){
    let ctx = this
    api.highlightsGet().then(function(r){ 
      ctx.imgs = r.data
      ctx.prepareLightbox(ctx.imgs)
      }).catch(e => console.error("cuold not get newest images"))
  }

  prepareLightbox(images :Image[]){
    console.log("prepare lightbox")
    let lbData = []
    for(let i in images){
      let lbImg = {
        src:  this.getImageUrl(this.imgs[i].filename),
      }
      lbData.push(lbImg)
    }
    console.log("alkmalknvcaoi: " + lbData.length)
    this.lbData = lbData
  }

getImageUrl(filename?: string) {
      if(filename){
        return ImagePath(filename)
      }
  }

    getImageCoverUrl(filename?: string) {
      if(filename){
        return ImageCoverPath(filename)
      }
  }

}
